export const commonIconClassName = 'size-6 [stroke-linecap:round] [stroke-linejoin:round] stroke-[1.8]'
